import React from 'react';

const LandingFooter = () => {
  return (
    <footer className="bg-white border-t">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center gap-2 mb-4 md:mb-0">
            <div className="w-6 h-6 bg-blue-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xs">AI</span>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-900">Assist</p>
              <p className="text-xs text-gray-500">University of Illinois Chicago</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;

